<script setup lang="ts">
import {DashboardWidgetProps} from "@/utils/presenters/interfaces.ts";
import {computed} from "vue";
import NamaTimelineWrapper from "@/components/EditView/NamaTimelineWrapper.vue";
import Translator from "@/utils/common/Translator.ts";
import DTOTimelineData = namaTypes.DTOTimelineData;

const props = defineProps<DashboardWidgetProps>();
const timelineActions = computed<DTOTimelineData[]>(() => props.chartLine.timeLineData ?? [])

const widgetId = props.chartLine.widgetId ?? "timeline"
</script>

<template>
  <div :key="chartKey + widgetId" class="tw-h-full tw-w-full tw-overflow-auto tw-px-0">
    <NamaTimelineWrapper
      :supportSnakeVerticalLayout="false"
      :timeline="timelineActions"
      :isHorizontal="props.chartLine.horizontalMode"
      :heading="Translator.calcByLanguage(props.chartLine.arChartTitle??'',props.chartLine.enChartTitle??'')"
    />
  </div>
</template>
